<template>
    <div class="menuContainer" role="navigation">
        <div class="pandoraMenuTabs">
            <MenuItem @click="item.action? item.action(): undefined" :text="item.title" v-for="(item, index) in props.menuitems" :key="`menu-${index}`" :titleactive="props.titleactive">
            </MenuItem>
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import MenuItem from '../menuItem/MenuItemTabs.vue';

import { defineProps } from 'vue';

const props = defineProps({
    titleactive: {
        type: String,
        default: ''
    },
    menuitems: {
        default: []
    }
});
</script>

<style scoped>
body * {
    margin: 0;
    padding: 0;
}

.menuContainer>.pandoraMenuTabs {
    display: ruby;
}

.menuContainer{
    background: #272833 !important;
    padding-top: 8px;
}

.menuContainer .pandoraMenuTabsitem>.pandoraMenuTabs {
    position: absolute;
    pointer-events: none;
}

.pandoraMenuTabsitem:hover>.pandoraMenuTabs {
    pointer-events: initial;
}

.menuContainer>.pandoraMenuTabs>.pandoraMenuTabsitem .pandoraMenuTabsitem .pandoraMenuTabs {
    transform: translateX(100%);
    top: 0;
    right: 0;
}
</style>